import { render } from "./getMoney.vue?vue&type=template&id=198821f2&scoped=true"
import script from "./getMoney.vue?vue&type=script&lang=js"
export * from "./getMoney.vue?vue&type=script&lang=js"

import "./getMoney.vue?vue&type=style&index=0&id=198821f2&scoped=true&lang=less"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198821f2"]])

export default __exports__